/* Reads the UK Judge.me featured HTML; rendering/interaction belongs to Symmetry. */
(() => {
  if (window.isunJudgeMeTestimonialsBound) return;
  window.isunJudgeMeTestimonialsBound = true;

  function init(section) {
    if (section.dataset.reviewsReady) return;
    const source = section.querySelector('[data-judgeme-source]');
    const cardTemplate = section.querySelector('[data-native-review-card]');
    const slideshowTemplate = section.querySelector('[data-native-review-slideshow]');
    const starTemplate = section.querySelector('[data-native-review-star]');
    if (!source || !cardTemplate || !slideshowTemplate || !starTemplate) return;
    const entries = Array.from(source.content.querySelectorAll('.jdgm-carousel-item[data-review-id]'));
    const fragment = slideshowTemplate.content.cloneNode(true);
    const slides = fragment.querySelector('.slideshow');
    let count = 0;

    entries.forEach((entry) => {
      const body = entry.querySelector('.jdgm-carousel-item__review-body');
      const ratingSource = entry.querySelector('.jdgm-carousel-item__review-rating');
      const rating = ratingSource?.querySelectorAll('.jdgm--on').length || 0;
      const starCount = ratingSource?.querySelectorAll('.jdgm-star').length || 0;
      const declaredRating = Number.parseFloat(ratingSource?.getAttribute('aria-label'));
      if (rating !== 5 || starCount !== 5 || (Number.isFinite(declaredRating) && declaredRating !== 5)) return;
      if (!body || !body.textContent.trim()) return;
      const card = cardTemplate.content.cloneNode(true);
      const slide = card.querySelector('.slideshow__slide');
      slide.dataset.reviewId = entry.dataset.reviewId;
      slide.style.setProperty('--slide-index', String(count + 1));
      if (!count) slide.classList.add('is-active');
      card.querySelector('.testimonial').classList.add(`testimonial-${count + 1}`);
      const quote = card.querySelector('[data-review-body]');
      // Text nodes retain the exact review wording without injecting app markup.
      const paragraphs = Array.from(body.querySelectorAll('p'));
      (paragraphs.length ? paragraphs : [body]).forEach((paragraph, index) => {
        if (index) quote.append(document.createElement('br'), document.createElement('br'));
        quote.append(document.createTextNode(paragraph.textContent.trim()));
      });
      const author = entry.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim();
      const authorNode = card.querySelector('[data-review-author]');
      if (author) authorNode.textContent = `— ${author}`;
      else authorNode.remove();
      const stars = card.querySelector('[data-review-stars]');
      if (rating > 0 && rating <= 5) {
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', source.dataset.starsLabel.replace('__rating__', String(rating)));
        for (let i = 0; i < rating; i += 1) stars.append(starTemplate.content.cloneNode(true));
      } else stars.remove();

      const image = card.querySelector('[data-review-image]');
      if (image) {
        const original = entry.querySelector('.jdgm-carousel-item__product-image');
        const imageSource = original?.getAttribute('data-src-retina') || original?.getAttribute('data-src') || original?.getAttribute('src');
        const fallback = card.querySelector('[data-review-image-fallback]');
        const label = original?.getAttribute('alt') || '';
        fallback.textContent = label;
        const noImage = () => { image.hidden = true; fallback.hidden = !label; };
        image.addEventListener('error', noImage, { once: true });
        try {
          const url = new URL(imageSource || '', location.origin);
          const isShopifyImage = url.hostname === 'cdn.shopify.com' || url.hostname === location.hostname;
          if (!imageSource || !isShopifyImage || !/^https?:$/.test(url.protocol)) throw new Error('No supported image');
          url.pathname = url.pathname.replace(/_(?:70x70|140x140)(?=\.[a-z]+$)/i, '');
          url.searchParams.set('width', '1000');
          const ratio = Number(image.dataset.aspectRatio);
          if (ratio > 0) {
            url.searchParams.set('height', String(Math.round(1000 / ratio)));
            url.searchParams.set('crop', 'center');
          }
          image.alt = label;
          image.src = url.href;
        } catch (_) { noImage(); }
      }
      slides.append(card);
      count += 1;
    });

    // Keep empty/malformed source out of the page; never fall back to US content.
    if (!count) return;
    if (count === 1) {
      fragment.querySelector('.slideshow-ctrl').remove();
      fragment.querySelector('slide-show').dataset.autoplay = 'false';
    }
    section.querySelector('.testimonial-list').dataset.testimonialCount = String(count);
    section.querySelector('[data-native-review-mount]').append(fragment);
    section.dataset.reviewsReady = 'true';
    section.hidden = false;
  }

  const scan = (root = document) => root.querySelectorAll('[data-judgeme-testimonials]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
